



















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import StoryboardItem from '@/components/StoryboardItem.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ShotThumbnail from '@/components/VideoTimeline/ShotThumbnail.vue'
import {IndexSignatureStrOfAny, SceneShot, Shot, ShotTypes, StillShot, TitleShot, VideoShot} from '@/store/shots'
import draggable from 'vuedraggable'
import ShotAddFabButton from '@/components/Shots/ShotAddFabButton.vue'
import AddShotDialog from '@/components/Shots/AddShotDialog.vue'
import DeleteShotDialog from '@/components/Shots/DeleteShotDialog.vue'
import VideoTimelineSettingsMenu from '@/components/VideoTimeline/VideoTimelineSettingsMenu.vue'
import {projectStore, userStore} from '@/store'

@Component({
  components: {
    VideoTimelineSettingsMenu,
    DeleteShotDialog, StoryboardItem, VuePerfectScrollbar, ShotThumbnail, draggable, ShotAddFabButton, AddShotDialog}
})
export default class VideoTimeline extends Vue {
  @Prop() shots!: Shot[]
  @Prop() selectedShot!: Shot
  scrollbarSettings = {
    suppressScrollX: true
  }
  dragOptions = {
    animation: 150
  }
  $refs!: {
    scrollArea: any;
  }
  ShotTypes = ShotTypes
  private shotClassTypes: IndexSignatureStrOfAny = {
    still: StillShot, video: VideoShot, scene: SceneShot, title: TitleShot,
  }
  dialog: {open: boolean; shot: Shot} = {
    open: false,
    // Note: Property modified by child components (AddShotDialog and it's child forms). Do not pass Vuex references!
    shot: new StillShot
  }
  deleteDialog: {open: boolean; shot: Shot | null} = {open: false, shot: null}
  // settings menu
  settingsOpen = false

  get project() {
    return projectStore.project
  }

  get thumbnailScale(): number | undefined {
    return userStore.profile?.ui.shotDesigner.shotTimeline.scale
  }

  set thumbnailScale(scale: number | undefined) {
    userStore.setUIStateShotDesignerShotTimelineScale(scale)
  }

  setThumbnailScale(scale: number) {
    this.thumbnailScale = scale
  }

  saveThumbnailScale() {
    userStore.saveProfile()
  }

  @Watch('settings.thumbnailScale') onThumbnailScaleChange(val: number, oldVal: number) {
    if (val !== oldVal)
      this.$refs.scrollArea.ps.update() // hack to update scrollbar on content size change
  }

  isCurrentShot(shot: Shot): boolean {
    return shot === this.selectedShot
  }

  setCurrentShot(shot: Shot): void {
    this.$emit('current-shot-selected', shot)
  }

  onDragChange(event: any) {
    // event is like {moved: {element: el, newIndex: 1, oldIndex: 0}}
    if ('moved' in event) {
      const change = event.moved
      this.$emit('shot-order-changed', {shot: change.element, newIndex: change.newIndex, oldIndex: change.oldIndex})
    }
  }

  openAddShotDialog(kind: ShotTypes) {
    // Note: Property modified by child components (AddShotDialog and it's child forms). Do not pass Vuex references!
    this.dialog.shot = new this.shotClassTypes[kind]({kind, durationInSec: 1})
    this.dialog.open = true
  }

  closeAddShotDialog() {
    this.dialog.open = false
  }

  saveNewShot() {
    if (!this.project)
      return

    try {
      this.dialog.shot.inPoint = 0
      this.dialog.shot.outPoint = this.dialog.shot.durationInSec
      projectStore.addShot(this.dialog.shot)
      this.dialog.open = false
      this.$toast.success('Shot saved.')
    } catch (err) {
      this.$toast.error('Shot save failed!')
      this.$log.error(err)
    }
  }

  closeDeleteShotDialog() {
    this.deleteDialog.open = false
    this.deleteDialog.shot = null
  }

  confirmShotDeletion(shot: Shot) {
    this.deleteDialog.open = true
    this.deleteDialog.shot = shot
  }

  async deleteShot() {
    if (this.deleteDialog.shot) {
      try {
        this.deleteDialog.open = false
        await projectStore.deleteShot(this.deleteDialog.shot)
        this.deleteDialog.shot = null
        this.$toast.info('Shot deleted.')
      } catch (e) {
        this.$toast.error(`Can't delete shot!`)
        this.$log.error(`Error deleting shot: ${JSON.stringify(e)}`)
      }
    }
  }
}
